export default __webpack_public_path__ + "static/media/NotificationIcon.e78692c7.svg";